import type { LocalRow } from '../types/localDb.types'

/**
 * Tag Repack (v7.50 A-03): barang hasil Repack claim hanya boleh keluar lewat Permintaan Gabungan (GAB-01 / GAB-02) dan
 * TIDAK PERNAH dipilih untuk order Pack tunggal (Order Pengiriman FG). Penanda: `origin = 'REPACK'` (stok pack) atau
 * `claim_category = 'REPACK'` (baris yang berasal dari claim).
 */
export const REPACK_ORIGIN = 'REPACK'

export const isRepack = (row: LocalRow | undefined | null) =>
  Boolean(row) && (row?.origin === REPACK_ORIGIN || row?.claim_category === REPACK_ORIGIN)

/** Penjaga order Pack tunggal: buang semua baris Repack dari kandidat pengambilan. */
export const withoutRepack = <T extends LocalRow>(rows: T[]) => rows.filter(row => !isRepack(row))
